import { connect } from 'react-redux';
import { OfferCardImageBanner } from './offer-card-image-banner';
import { ITrackingReducerState } from '../../../../store/tracking';
import { IState } from '../../../../store';

export interface IOfferCardImageBannerStateProps {
  tracking: ITrackingReducerState;
}

export const mapStateToProps = (state: IState): IOfferCardImageBannerStateProps => {
  return {
    tracking: state.tracking,
  };
};

export const OfferCardImageBannerContainer = connect<IOfferCardImageBannerStateProps>(mapStateToProps)(
  OfferCardImageBanner,
);
